import {RemoteCollectionStore} from '@softline/core';
import {Contact} from './data/contact.model';
import {Customer} from './data/customer.model';

export const SOFTLINE_FEATURE_REGISTRATION_ADMIN_CONTACTS = 'registrationAdminContacts';
export const SOFTLINE_FEATURE_REGISTRATION_ADMIN_CUSTOMERS = 'registrationAdminCustomer';
export const SOFTLINE_FEATURE_REGISTRATION_ADMIN_ADMIN = 'registrationAdminAdmin';

export const SOFTLINE_PERMISSION_REGISTRATION_ADMIN = 'REGISTRIERUNG_FREISCHALTEN';

export const RegistrationAdminContactsStore = RemoteCollectionStore.create<Contact>();
export const RegistrationAdminCustomersStore = RemoteCollectionStore.create<Customer>();
